import styled from 'styled-components';

export const Chip = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  background: theme.colors.surface03,
  borderRadius: 100,
  overflow: 'hidden',
  flexWrap: 'nowrap',
  padding: `${theme.spacing[4]} ${theme.spacing[8]}`,
}));
